import Btn from './Button';
import Ad from './Ad';
import ReactModal  from 'react-modal';
import External from './Extrenal';
import { Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const UserPics = (props) => {
     const [isOpen, setPopupIsOpen] = useState(false);
     const [currentpic, setCurrentPic] = useState("");
     const [currentname, setCurrentName] = useState("");
     const [currentcomment, setCurrentComment] = useState("");
     const [isSinglePicModalOpen, setSinglePicModalIsOpen] = useState(false);
     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
     const { t } = useTranslation();
     const toggleOpen = () => {
        
        setPopupIsOpen(!isOpen);
      }
    const toggleSinglePicOpen = () => {
        
        setSinglePicModalIsOpen(!isSinglePicModalOpen);
      }
    const openSinglePicModal = (pic, comment, name) => {
      setCurrentPic(pic);
      setCurrentName(name);
      setCurrentComment(comment);
      setSinglePicModalIsOpen(true);
    } 
    const morePics = () => {
       
        toggleOpen();
        };

    
      const customStyles = {
        content: {
          width:(screenWidth > 1200 ) ? screenWidth*0.8 +'px' :'100%',
          padding: '5px',
          top: '0',
          left: '0',
          direction: (props.lang == 1) ? 'rtl' : '',
          right: 'auto',
          bottom: '0',
          position: 'absolute',
          marginRight: '',
          transform: '',
        },
      };
      useEffect(() => {
                    const handleResize = () => {
                        setScreenWidth(window.innerWidth);
                        //alert(window.innerWidth);
            
                    };
                    
                    handleResize();
                    window.addEventListener('resize', handleResize);
            
                    // Clean up the event listener when the component unmounts
                    return () => {
                        window.removeEventListener('resize', handleResize);
                    };
                    
                    }, []); // Empty dependency array means this effect runs once on mount
                    
    return (
  <div id="userpicscontainer" className="row">
    <h4>{t('USERS_PICS')}</h4>

    {props.userPics.map((pic, i) => {
      const tiny = `thumb.php?src=${encodeURIComponent(pic.picname)}&w=30&h=30`;
      const full = `thumb.php?src=${encodeURIComponent(pic.picname)}&w=280&h=280`;

      return (
        <div
          className="col align-self-start col-4 col-md-4 col-lg-auto col-xl-auto mx-auto parambox userpic"
          key={i}
        >
          <Link
            onClick={() => openSinglePicModal(pic.picname, pic.comment, pic.name)}
            onMouseEnter={() => {
              // preload full image for smoother modal
              const img = new Image();
              img.src = `https://v2013.02ws.co.il/${pic.picname}`;
            }}
          >
            <div className="progressive-wrapper">
              {/* tiny blurred image */}
              <img
                src={`https://v2013.02ws.co.il/${tiny}`}
                alt=""
                className="progressive-img blur"
              />

              {/* full image */}
              <img
                src={`https://v2013.02ws.co.il/${full}`}
                loading="lazy"
                alt=""
                className="progressive-img full rounded img-fluid"
                onLoad={(e) => {
                  const blurImg = e.target.previousSibling;
                  if (blurImg) blurImg.style.opacity = 0;
                  e.target.style.opacity = 1;
                }}
              />
            </div>
          </Link>

          <br />

          <Link onClick={() => openSinglePicModal(pic.picname)}>
            <div className="comment">{pic.comment}</div>
          </Link>

          <div className="name">{pic.name}</div>

          {i % 4 == 0 && (
            <Ad width={300} height={300} format="fluid" slot="1823672538" />
          )}
        </div>
      );
    })}

    <br />
    <br />

    <Btn
      btnOnClick={() => morePics()}
      btnTitleText={t('MORE_USERS_PICS')}
      img={props.lang == 1 ? "ArrowLeft" : "ArrowRight"}
    />

    <ReactModal
      isOpen={isOpen}
      contentLabel="Example Modal"
      style={customStyles}
      onRequestClose={() => toggleOpen(false)}
    >
      <Btn
        btnOnClick={() => toggleOpen(false)}
        btnTitleText={""}
        img={"X"}
        cssClasses={props.lang == 1 ? "float-start" : "float-end"}
      />

      <div className="sidepopup">
        <External
          src={
            "https://v2013.02ws.co.il/small/?section=userPics.php&lang=" +
            props.lang
          }
          width="100%"
          height="95%"
          className={props.cssClasses}
        />
      </div>
    </ReactModal>

    <ReactModal
      isOpen={isSinglePicModalOpen}
      contentLabel="Single pic Modal"
      style={customStyles}
      onRequestClose={() => toggleSinglePicOpen(false)}
    >
      <Btn
        btnOnClick={() => toggleSinglePicOpen(false)}
        btnTitleText={""}
        img={"X"}
        cssClasses={props.lang == 1 ? "float-start" : "float-end"}
      />

      <div className="mt-3">
        <div className="name">{currentname}</div>
        <div className="comment">{currentcomment}</div>
        <img
          src={`https://v2013.02ws.co.il/${currentpic}`}
          alt=""
          className="rounded img-fluid popup-img"
        />
      </div>
    </ReactModal>
  </div>
);
}

export default UserPics; 